var _ = require('lodash')

// global
var Settings = {
  author: 'Dpt',
  name: 'ORIGIN VUE',
  id: 'origin_vue',
  cookies: {
    lang: 'origin_vue_lang',
  },
  locale: ['fr', 'en'],
  // activer ou non le smoothscroll
  smoothScroll: true,
  loader: true,

  fast: false,
  volume: true,
  isDev: process.env.NODE_ENV !== 'production',

  ua_code: {
		global: 'UA-32257069-1',
    project: 'UA-42015401-32',
  },
  onfUrl: {},

  cdn: 'https://d1yq0j8y1js459.cloudfront.net',
  // cdn: '/',

  // can be 'out-in', 'in-out' or ''
  mode: '',
  // prefix les routes avec les lang disponible
  // ex : fr/accueil
  prefixRoute: false,
  // Si vue est utiliser avec un CMS (craft ou wordpress)
  cms: false,
  // Si electron/cordova ou local server,
  // localAssets: true,
  localAssets: false,
  // build le projet dans ce path, si electron ou cordova changer ici
  dist: {
    root: '../dist',
    subfolder: '',

    // root: '../cordova',
    // subfolder: 'www'
  },
  // api
  API_PREFIX: 'wp-json/acf/v3',
  ADMIN_PREFIX: 'cms'
}

// dev
if((process.env.NODE_ENV !== 'production'))
{
  Settings.onfUrl = {
    fr: 'ws.demotte.net',
    en: ''
  }
}
// production
else
{
  Settings.onfUrl = {
    fr: 'roxham-onf.dpt.media',
    en: 'roxham-nfb.dpt.media'
  }
}

if(typeof(window) !== 'undefined') {
  // disable loader for prerender.io
  if (/PhantomJS/.test(window.navigator.userAgent))
    Settings.loader = false

  // OVERWRITE BY PHP ENV
  if(typeof(window) !== 'undefined' && window.__ENV !== undefined)
    Settings = _.merge(Settings, window.__ENV)

  // dev onf
  if(window.location.hostname == 'roxham-dev.onf.ca' || window.location.hostname == 'roxham-dev.nfb.ca') {
    Settings.onfUrl = {
      fr: 'roxham-dev.onf.ca',
      en: 'roxham-dev.nfb.ca'
    }
  }

  // real prod
  if(window.location.hostname == 'roxham.onf.ca' || window.location.hostname == 'roxham.nfb.ca') {
    Settings.onfUrl = {
      fr: 'roxham.onf.ca',
      en: 'roxham.nfb.ca'
    }
  }
}

// concat BASE_URL + PREFIX
Settings['API_URL'] = Settings.BASE_URL + '/' + Settings.API_PREFIX + '/'

if(process.env.NODE_ENV === 'production') {
  Settings.fast = false
  Settings.volume = true
}

module.exports = Settings




// WEBPACK FOOTER //
// ./src/config/Settings.js